import { render, staticRenderFns } from "./SettingsContentWrapper.vue?vue&type=template&id=9dd5d674&scoped=true&"
import script from "./SettingsContentWrapper.vue?vue&type=script&lang=ts&"
export * from "./SettingsContentWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsContentWrapper.vue?vue&type=style&index=0&id=9dd5d674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd5d674",
  null
  
)

export default component.exports